// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"anchor-tag_uk-open__ZNbf7","grecaptcha-badge":"anchor-tag_grecaptcha-badge__mPFhx","tag":"anchor-tag_tag__OrSoe"};
    if(module.hot) {
      // 1793877040404
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  